import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getShows } from "./action";

export const showsEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = showsEntityAdapter.getInitialState({
  count: 0,
  selectShow: {},
});

export const showsSlice = createSlice({
  name: "shows",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getShows.fulfilled, (state, action) => {
      if (action.payload.status) {
        showsEntityAdapter.setAll(state, action.payload.data);
      }
    });
  },
});

export default showsSlice.reducer;
